// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.toolbar-container {
  position: absolute;
  background: rgba(42, 42, 42, 0.8);
  /* left is auto, so the horizontal offset comes from the margin, not from \`left\`. */
  margin: calc(5px + var(--safe-top)) 5px 5px calc(5px + var(--safe-left));
  padding: 2px 5px;
  border-radius: 4px;
  top: 0px;
  max-height: 400px;
  overflow-y: auto;
  /* Enable vertical scroll */
  /* A long pilot name plus the labels and icons can run past a phone's screen.
     Desktop sits far inside this, so the cap only bites on small screens.
     Mirrors the margin above, insets included. */
  max-width: calc(100vw - 10px - var(--safe-left) - var(--safe-right));
  overflow-x: auto;
  /* The solo, camera and cinema icons sit shoulder to shoulder — \`.zoom\`'s 5px
     each side cost ~20px of row width between every pair of 20px icons. */
}
.toolbar-container input {
  vertical-align: middle;
  padding-top: 2px;
  padding-bottom: 2px;
}
.toolbar-container .zoom {
  margin: 5px;
}
.toolbar-container .zoom:hover {
  cursor: pointer;
  /* margin: 10px; */
}
.toolbar-container .camera-unfollow {
  opacity: 0.1;
}
.toolbar-container .cinema-off {
  opacity: 0.1;
}
.toolbar-container .solo-off {
  opacity: 0.1;
}
.toolbar-container .selected {
  color: greenyellow;
  font-weight: bold;
}
.toolbar-container .icon-cell {
  padding: 0;
  white-space: nowrap;
}
.toolbar-container .icon-button {
  display: inline-block;
  margin: 0 1px;
  vertical-align: middle;
}
.toolbar-container .icon-button:hover {
  cursor: pointer;
}

/* unvisited link */
#upload_link:link {
  color: white;
}

/* visited link */
#upload_link:visited {
  color: white;
}

/* mouse over link */
#upload_link:hover {
  color: white;
}

/* selected link */
#upload_link:active {
  color: white;
}

/* Custom Scrollbar for WebKit browsers */
.toolbar-container::-webkit-scrollbar {
  width: 12px;
}

.toolbar-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.toolbar-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.toolbar-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Scrollbar for other browsers (using CSS variables) */
.toolbar-container {
  scrollbar-color: #888 #f1f1f1;
  scrollbar-width: thin;
}`, "",{"version":3,"sources":["webpack://./src/burnair/modules/toolBar.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,kBAAA;EACA,iCAAA;EACA,mFAAA;EACA,wEAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA;;iDAAA;EAGA,oEAAA;EACA,gBAAA;EAwCA;0EAAA;AApCJ;AAFI;EACI,sBAAA;EACA,gBAAA;EACA,mBAAA;AAIR;AAAI;EACI,WAAA;AAER;AACI;EACI,eAAA;EACA,kBAAA;AACR;AAEI;EACI,YAAA;AAAR;AAGI;EACI,YAAA;AADR;AAII;EACI,YAAA;AAFR;AAKI;EACI,kBAAA;EACA,iBAAA;AAHR;AAMI;EACI,UAAA;EACA,mBAAA;AAJR;AASI;EACI,qBAAA;EACA,aAAA;EACA,sBAAA;AAPR;AASQ;EACI,eAAA;AAPZ;;AAYA,mBAAA;AACA;EACI,YAAA;AATJ;;AAYA,iBAAA;AACA;EACI,YAAA;AATJ;;AAYA,oBAAA;AACA;EACI,YAAA;AATJ;;AAYA,kBAAA;AACA;EACI,YAAA;AATJ;;AAYA,yCAAA;AACA;EACI,WAAA;AATJ;;AAYA;EACI,mBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,gBAAA;EACA,kBAAA;AATJ;;AAYA;EACI,gBAAA;AATJ;;AAYA,uDAAA;AACA;EACI,6BAAA;EACA,qBAAA;AATJ","sourcesContent":[".toolbar-container {\n    position: absolute;\n    background: rgba(42, 42, 42, 0.8);\n    /* left is auto, so the horizontal offset comes from the margin, not from `left`. */\n    margin: calc(5px + var(--safe-top)) 5px 5px calc(5px + var(--safe-left));\n    padding: 2px 5px;\n    border-radius: 4px;\n    top: 0px;\n    max-height: 400px;\n    overflow-y: auto;\n    /* Enable vertical scroll */\n    /* A long pilot name plus the labels and icons can run past a phone's screen.\n       Desktop sits far inside this, so the cap only bites on small screens.\n       Mirrors the margin above, insets included. */\n    max-width: calc(100vw - 10px - var(--safe-left) - var(--safe-right));\n    overflow-x: auto;\n\n    input {\n        vertical-align: middle;\n        padding-top: 2px;\n        padding-bottom: 2px;\n    }\n\n\n    .zoom {\n        margin: 5px;\n    }\n\n    .zoom:hover {\n        cursor: pointer;\n        /* margin: 10px; */\n    }\n\n    .camera-unfollow {\n        opacity: 0.1;\n    }\n\n    .cinema-off {\n        opacity: 0.1;\n    }\n\n    .solo-off {\n        opacity: 0.1;\n    }\n\n    .selected {\n        color: greenyellow;\n        font-weight: bold;\n    }\n\n    .icon-cell {\n        padding: 0;\n        white-space: nowrap;\n    }\n\n    /* The solo, camera and cinema icons sit shoulder to shoulder — `.zoom`'s 5px\n       each side cost ~20px of row width between every pair of 20px icons. */\n    .icon-button {\n        display: inline-block;\n        margin: 0 1px;\n        vertical-align: middle;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n}\n\n/* unvisited link */\n#upload_link:link {\n    color: white;\n}\n\n/* visited link */\n#upload_link:visited {\n    color: white;\n}\n\n/* mouse over link */\n#upload_link:hover {\n    color: white;\n}\n\n/* selected link */\n#upload_link:active {\n    color: white;\n}\n\n/* Custom Scrollbar for WebKit browsers */\n.toolbar-container::-webkit-scrollbar {\n    width: 12px;\n}\n\n.toolbar-container::-webkit-scrollbar-track {\n    background: #f1f1f1;\n    border-radius: 4px;\n}\n\n.toolbar-container::-webkit-scrollbar-thumb {\n    background: #888;\n    border-radius: 4px;\n}\n\n.toolbar-container::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n/* Scrollbar for other browsers (using CSS variables) */\n.toolbar-container {\n    scrollbar-color: #888 #f1f1f1;\n    scrollbar-width: thin;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
